import type { Locale } from '../i18n/resources';
import type { AppTheme } from './theme';

export const PAGE_SIZES = [5, 10, 25, 50, 100] as const;

export const DOCUMENT_PAGE_SIZES = PAGE_SIZES;
export const GALLERY_PAGE_SIZES = PAGE_SIZES;
export const CHATBOT_CONVERSATIONS_PAGE_SIZES = PAGE_SIZES;
export const CHATBOT_TRAINING_EXAMPLES_PAGE_SIZES = PAGE_SIZES;

export type PageSize = (typeof PAGE_SIZES)[number];
export type DocumentPageSize = PageSize;
export type GalleryPageSize = PageSize;
export type ChatbotConversationsPageSize = PageSize;
export type ChatbotTrainingExamplesPageSize = PageSize;

export const DEFAULT_DOCUMENT_PAGE_SIZE: DocumentPageSize = 10;
export const DEFAULT_GALLERY_PAGE_SIZE: GalleryPageSize = 10;
export const DEFAULT_CHATBOT_CONVERSATIONS_PAGE_SIZE: ChatbotConversationsPageSize = 10;
export const DEFAULT_CHATBOT_TRAINING_EXAMPLES_PAGE_SIZE: ChatbotTrainingExamplesPageSize = 10;

export const USER_CONFIG_KEYS = [
  'theme',
  'locale',
  'knowledgeDocumentsPageSize',
  'galleryImagesPageSize',
  'chatbotConversationsPageSize',
  'chatbotTrainingExamplesPageSize',
  'pinnedKnowledgeDatabaseIds',
  'replacePlatformChatDraftTextOnTranscription',
  'keepSidebarOpen',
  'platformChatLastSeenMessageIds',
  'platformChatMaxResults',
  'platformChatMinScore',
] as const;

export type UserConfigKey = (typeof USER_CONFIG_KEYS)[number];

export type UserConfig = {
  theme?: AppTheme;
  locale?: Locale;
  knowledgeDocumentsPageSize?: DocumentPageSize;
  galleryImagesPageSize?: GalleryPageSize;
  chatbotConversationsPageSize?: ChatbotConversationsPageSize;
  chatbotTrainingExamplesPageSize?: ChatbotTrainingExamplesPageSize;
  pinnedKnowledgeDatabaseIds?: string[];
  replacePlatformChatDraftTextOnTranscription?: boolean;
  keepSidebarOpen?: boolean;
  /** sessionId → last seen platform message id (shared chats only). */
  platformChatLastSeenMessageIds?: Record<string, string>;
  /** Max knowledge-base RAG matches per platform-chat turn. */
  platformChatMaxResults?: number;
  /** Min similarity score for platform-chat knowledge-base RAG matches. */
  platformChatMinScore?: number;
};

export type ResolvedUserConfig = {
  theme: AppTheme;
  locale: Locale;
  knowledgeDocumentsPageSize: DocumentPageSize;
  galleryImagesPageSize: GalleryPageSize;
  chatbotConversationsPageSize: ChatbotConversationsPageSize;
  chatbotTrainingExamplesPageSize: ChatbotTrainingExamplesPageSize;
  pinnedKnowledgeDatabaseIds: string[];
  replacePlatformChatDraftTextOnTranscription: boolean;
  keepSidebarOpen: boolean;
  platformChatLastSeenMessageIds: Record<string, string>;
  platformChatMaxResults: number;
  platformChatMinScore: number;
};
